import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, Redirect } from "react-router-dom";
import HomeRoute from "../Modules/Home/Routes/HomeRoute";
import PaymentRoute from "../Modules/Payment/Routes/PaymentRoute";
import LoginRoute from "../../GlobalModules/Login/Routes/LoginRoute";
import BookingRoute from "../Modules/Booking/Routes/BookingRoute";
import { connect } from 'react-redux';
import { setToken } from '../../GlobalModules/Login/Actions/LoginAction';
import { withNamespaces } from 'react-i18next';
// import ProfileRoute from "../../GlobalModules/UserProfile/Routes/ProfileRoute";
import FooterListRoute from "../../GlobalModules/FooterList/Routes/FooterListRoute";
const ContactFormPage = lazy(() => import('../Modules/ContactForm/Pages/ContactFormPage'));


class index extends Component {
  render() {
    const { isLoggedIn, userCredentials } = this.props;
    return (
      <Switch>
        <Route exact path="/" component={HomeRoute} />
        <Route
          exact
          path="/tour-list"
          render={() => {
            const lng = localStorage.getItem('i18nextLng') || 'en';
            return <Redirect to={`/${lng}/tour-list`} />;
          }}
        />
        <Route
          path="/:lng/home"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/tour-list"
          render={(routeProps) => (
            <HomeRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/folio-history"
          render={(routeProps) => (
            <HomeRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/tour-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/property-type-list"
          render={(routeProps) => (
            <HomeRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/search"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route exact path="/:lng/notfound" component={HomeRoute} />
        <Route exact path="/:lng/login/:type?" component={LoginRoute} />
        <Route exact path="/:lng/forgot-password/:type?" component={LoginRoute} />
        <Route exact path="/:lng/register/:type?" component={LoginRoute} />
        <Route exact path="/:lng/comingsoon" component={HomeRoute} />
        {/* <Route
          path="/:lng/manage-account"
          render={(routeProps) => (
            <ProfileRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        /> */}
        {/* <Route
          path="/:lng/change-password"
          render={(routeProps) => (
            <ProfileRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        /> */}

        <Route
          path="/:lng/booking-history/:customer_type?"
          render={(routeProps) => (
            <BookingRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/booking-details"
          render={(routeProps) => (
            <BookingRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/property-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/tour-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/about-us"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/terms-conditions"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/faq"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/privacy-policy"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/sitemap"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/credit-note"
          render={(routeProps) => (
            <BookingRoute {...routeProps} />
          )}
        />
        <Route
          path={["/prospect-form", "/:lng/prospect-form", "/:lng/contact-form/:type", "/:lng/contact-form"]}
          render={(routeProps) => (
            <ContactFormPage {...routeProps} />
          )}
        />
        <Route
          path="*"
          render={() => {
            const lng = localStorage.getItem('i18nextLng') || 'en';
            return <Redirect to={`/${lng}/notfound`} />;
          }}
        />
        <Route
          path="*"
          render={() => {
            const lng = localStorage.getItem('i18nextLng') || 'en';
            return <Redirect to={`/${lng}/comingsoon`} />;
          }}
        />

      </Switch>
    );
  }
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    isLoggedIn: globalState.LoginReducer.token !== '',

  };
}

export default connect(mapStateToProps, { setToken })(withNamespaces()(index));